import { Price, PriceSuffix } from "../api/models/prices.models";

export enum PriceType {
  PerYear,
  PerKg,
  PerContract,
  ForBusiness,
  ForConsumer,
}

export const getCombinedPrice = (
  amountKg: number,
  pricesData: Price[] | undefined,
  ecomodId?: number,
  supId?: number,
  priceType?: PriceType
): number => {
  if (!pricesData) return 0;

  const priceEntry = supId
    ? pricesData.find((price) => price.supClassId === supId)
    : pricesData.find((price) => price.ecomodClassId === ecomodId);

  if (!priceEntry) return 0;

  switch (priceType) {
    case PriceType.PerYear:
      const foundPrice = priceEntry.priceInfo.find(
        (info) => info.suffix === PriceSuffix.PerYear
      );
      return foundPrice ? foundPrice.amount * amountKg : 0;

    case PriceType.PerKg:
      const perKgPrice = priceEntry.priceInfo.find(
        (info) => info.suffix === PriceSuffix.PerKg
      );
      return perKgPrice ? perKgPrice.amount * amountKg : 0;

    case PriceType.PerContract:
      const perContractPrice = priceEntry.priceInfo.find(
        (info) => info.suffix === PriceSuffix.PerContract
      );
      return perContractPrice ? perContractPrice.amount : 0;

    case PriceType.ForBusiness:
      const forBusinessPrice = priceEntry.priceInfo.find(
        (info) => info.suffix === PriceSuffix.ForBusiness
      );
      return forBusinessPrice ? forBusinessPrice.amount * amountKg : 0;

    case PriceType.ForConsumer:
      const forConsumerPrice = priceEntry.priceInfo.find(
        (info) => info.suffix === PriceSuffix.ForConsumer
      );

      return forConsumerPrice ? forConsumerPrice.amount * amountKg : 0;

    default:
      console.warn("Price type not defined for combined price calculation");
      return 0;
  }
};

export const getRowPrice = (
  amountKg: number,
  pricesData: Price[] | undefined,
  ecomodId?: number,
  supId?: number,
  priceType?: PriceType
): number => {
  if (!pricesData) return 0;

  const priceEntry = supId
    ? pricesData.find((price) => price.supClassId === supId)
    : pricesData.find((price) => price.ecomodClassId === ecomodId);

  if (!priceEntry) return 0;

  switch (priceType) {
    case PriceType.PerYear:
      const foundPrice = priceEntry.priceInfo.find(
        (info) => info.suffix === PriceSuffix.PerYear
      );
      return foundPrice ? foundPrice.amount * amountKg : 0;

    case PriceType.PerKg:
      const perKgPrice = priceEntry.priceInfo.find(
        (info) => info.suffix === PriceSuffix.PerKg
      );
      return perKgPrice ? perKgPrice.amount * amountKg : 0;

    case PriceType.PerContract:
      const perContractPrice = priceEntry.priceInfo.find(
        (info) => info.suffix === PriceSuffix.PerContract
      );
      return perContractPrice ? perContractPrice.amount : 0;

    case PriceType.ForBusiness:
      const forBusinessPrice = priceEntry.priceInfo.find(
        (info) => info.suffix === PriceSuffix.ForBusiness
      );
      return forBusinessPrice ? forBusinessPrice.amount * amountKg : 0;

    case PriceType.ForConsumer:
      const forConsumerPrice = priceEntry.priceInfo.find(
        (info) => info.suffix === PriceSuffix.ForConsumer
      );

      return forConsumerPrice ? forConsumerPrice.amount * amountKg : 0;

    default:
      console.warn("Price type not defined for row price calculation");
      return 0;
  }
};
